// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"eaf6ca78","391":"3068a796","455":"9981863a","488":"c0688602","685":"ea0eed53","695":"0637c9ec","977":"7132f7e9"}[chunkId] + ".chunk.js";
};